import {z} from '@hono/zod-openapi';

export const importHondaPartsPriceListResultSchema = z.object({
  totalDataRows: z.number().int().nonnegative(),
  importedCount: z.number().int().nonnegative(),
  deactivatedCount: z.number().int().nonnegative(),
});

export type ImportHondaPartsPriceListResult = z.infer<typeof importHondaPartsPriceListResultSchema>;
